module.exports = __webpack_public_path__ + "img/zz-row-six.c0539240.svg";